import React, { useEffect, useState } from "react";
import { ExpandableAccordion } from "..";
import AccordionPawIcon from "../Icons/AccordionPawIcon";
import AccordionProcedureIcon from "../Icons/AccordionProcedureIcon";
import AccordionVaccinationIcon from "../Icons/AccordionVaccinationIcon";
import AccordionStethIcon from "../Icons/AccordionStethIcon";
import AccordionPreventativeIcon from "../Icons/AccordionPreventativeIcon";
import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import { userActivityLogger } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import AccordionExamsIcon from "../Icons/AccordionExamsIcon";

interface IWellnessData {
  surgery: { [key: string]: string[] };
  vaccination: { [key: string]: string[] };
  diagnostic: { [key: string]: string[] };
  preventative: { [key: string]: string[] };
}

const wellnessData: IWellnessData = {
  surgery: {
    "1": [
      "Dental cleaning or spay/neuter",
    ],
    "2": [
      "Dental cleaning or spay/neuter",
    ],
  },
  vaccination: {
    "1": [
      "Rabies vaccine",
      "Distemper vaccine",
      "Leptospirosis vaccine",
      "Bordetella vaccine",
      "Influenza vaccine",
    ],
    "2": [
      "Rabies vaccine",
      "Distemper (FVRCP) vaccine",
      "Leukemia (FeLV) vaccine",
    ],
  },
  diagnostic: {
    "1": [
      "Fecal screening",
      "Heartworm / tick screening",
      "Comprehensive bloodwork",
      "Urinalysis",
    ],
    "2": [
      "Fecal screening",
      "Heartworm screening",
      "FIV screening",
      "FeLV screening",
      "Comprehensive bloodwork",
      "Urinalysis",
    ],
  },
  preventative: {
    "1": [
      "Heartworm, flea and tick",
    ],
    "2": [
      "Heartworm, flea and tick",
    ],
  },
};

interface IWellnessAccordionList {
  petSpecies: string;
  removeBorder?:boolean;
  currentPetDetails?:IPetItemResponse[];
}

const WellnessAccordionList = ({ petSpecies, currentPetDetails, removeBorder=false }: IWellnessAccordionList) => {
  const [expandedAccordion, setExpandedAccordion] = useState<string>("");
  let descriptionList=[];
  const getDescription = (socType: keyof IWellnessData) => {
    descriptionList = wellnessData[socType][petSpecies];

    return (
      <ul className="list-disc">
        {descriptionList.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  };

  const handAccordionExpansion = (tileTitle: string) =>{
    setExpandedAccordion(tileTitle);
  };

  useEffect(()=>{
    if ((expandedAccordion !== "") && currentPetDetails) {
      userActivityLogger(MIXPANEL_EVENTS.BENEFIT_DETAILS_EXPANSION,
        {
          pet_id: currentPetDetails[0].id,
          pet_name: currentPetDetails[0].name,
          benefit_type: expandedAccordion,
        });
    }
  }, [expandedAccordion]);

  return (
    <div className="flex flex-col gap-2 w-full">
      <ExpandableAccordion
        removeBorder={removeBorder}
        onExpand={handAccordionExpansion}
        icon={<AccordionExamsIcon />}
        title={"Unlimited General Exams"}
        titleJsx={<><span className="text-violet-1">Unlimited</span> General Exams</>}
      />
      <ExpandableAccordion
        removeBorder={removeBorder}
        onExpand={handAccordionExpansion}
        icon={<AccordionPawIcon />}
        title={"Nail Trims"}
      />
      <ExpandableAccordion
        removeBorder={removeBorder}
        onExpand={handAccordionExpansion}
        description={getDescription("surgery")}
        icon={<AccordionProcedureIcon />}
        title={"One Surgical Procedure"}
      />
      <ExpandableAccordion
        removeBorder={removeBorder}
        onExpand={handAccordionExpansion}
        description={getDescription("vaccination")}
        icon={<AccordionVaccinationIcon />}
        title={"Vaccinations"}
      />
      <ExpandableAccordion
        removeBorder={removeBorder}
        onExpand={handAccordionExpansion}
        description={getDescription("diagnostic")}
        icon={<AccordionStethIcon />}
        title={"Diagnostics"}
      />
      <ExpandableAccordion
        removeBorder={removeBorder}
        onExpand={handAccordionExpansion}
        description={getDescription("preventative")}
        icon={<AccordionPreventativeIcon />}
        title={"Preventative Care"}
      />
    </div>
  );
};

export default WellnessAccordionList;
